import { clsx } from 'clsx'
import { formatDistanceToNow, differenceInCalendarDays, parseISO } from 'date-fns'
import { toaster } from 'src/Common/ui/Toaster'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export const base64ToPdf = (base64) => {
    try {
        const byteCharacters = atob(base64)
        const byteArray = new Uint8Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i)
        }
        return new Blob([byteArray], { type: 'application/pdf' })
    } catch (error) {
        console.error('Error decoding base64 to PDF:', error)
        return null
    }
}

export const indTimeConvert = (value) => {
    const currentDate = new Date(value.getTime() + (5.5 * 60 * 60 * 1000))
    return currentDate
}

export const ConvertBase64ToFile = (base64String, fileName, contentType) => {
    try {
        const cleanBase64String = base64String.replace(/\s/g, '')
        const byteCharacters = atob(cleanBase64String)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const file = new Blob([byteArray], { type: contentType })
        return [byteArray, new File([file], fileName, { type: contentType })]
    } catch (error) {
        console.error('Error converting base64 to file:', error)
    }
}
export const compAnswerDateConvert = (value) => {
    if (value) {
        const date = new Date(value)
        return `${date?.getDate() < 10 ? '0' : ''}${date?.getDate()}/${date?.getMonth() < 10 ? '0' : ''}${date?.getMonth() + 1}/${date?.getFullYear()}`
    } else {
        return null
    }
}
export const inputValidation = (value, condition, validation1, validation2, required = true) => {
    const regexPhone = () => {
        if (condition) {
            return true
        } else {
            return false
        }
    }
    if (!value && required) {
        return validation1
    } else if (!regexPhone() && value?.length > 0) {
        return validation2
    } else {
        return true
    }
}

export const roleColor = (name) => {
    if (name?.includes('Compliance')) {
        return 'hsl(var(--Compliance))'
    } else if (name?.includes('Risk')) {
        return 'hsl(var(--Risk))'
    } else if (name?.includes('Board')) {
        return 'hsl(var(--Governance))'
    } else {
        return 'hsl(var(--muted))'
    }
}

export const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })
}

export const formatDistToNow = (dat) => {
    const date = new Date(dat)
    return formatDistanceToNow(date, { addSuffix: true })
}

export const featValid = (data, value) => {
    return data?.find((ele) => ele.featureName === value)
}

export const validateAndProcessImage = (file, setSelectedImage, setnewNode, t, toast, key = null) => {
    if (!file) return
    if (file.size > 2 * 1024 * 1024) {
        toaster('warning', t('Image size should not exceed 2MB'))
        return null
    }
    const reader = new FileReader()
    reader.onloadend = () => {
        const dotIndex = file.name.lastIndexOf('.')
        const fileNameWithoutExtension = dotIndex !== -1 ? file.name.slice(0, dotIndex) : file.name

        const fileObject = {
            file: reader.result.split(',')[1],
            contentType: file.type,
            fileName: fileNameWithoutExtension
        }

        setSelectedImage(file)
        setnewNode((prevNode) => ({
            ...prevNode,
            [key ?? 'profilePic']: fileObject
        }))
    }
    reader.readAsDataURL(file)
}

export const getOrdinalSuffix = (num) => {
    if (num >= 11 && num <= 13) return `${num}th` // Special case for 11th, 12th, 13th
    const lastDigit = num % 10

    switch (lastDigit) {
        case 1:
            return `${num}st`
        case 2:
            return `${num}nd`
        case 3:
            return `${num}rd`
        default:
            return `${num}th`
    }
}

export const calculateDaysAgo = (baseDate, targetDate) => {
    const oneDay = 24 * 60 * 60 * 1000
    const diffDays = Math.round(Math.abs((baseDate - targetDate) / oneDay))
    return `${diffDays} days ago`
}
export const formatDateParts = (dateString) => {
    const date = new Date(dateString)

    // Get "Feb 2025"
    const datePart = date.toLocaleString('en-US', { month: 'short', year: 'numeric' })

    // Get "05:34 PM"
    const timePart = date.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }).replace(/^0/, '')

    return { datePart, timePart }
}
export const formatDate = (dateString) => {
    const date = new Date(dateString)

    // Get "Feb 11, 2025"
    const formattedDate = date?.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    })

    return formattedDate
}

export const getDueBasedAging = (isoDate) => {
    const creationDate = new Date(isoDate).setUTCHours(0, 0, 0, 0)
    const currentDate = new Date().setUTCHours(0, 0, 0, 0)

    // Calculate difference in days
    const differenceInTime = creationDate - currentDate
    const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24))

    // Return appropriate label
    if (differenceInDays === 0) return 1
    if (differenceInDays === 1) return 1
    return Math.abs(differenceInDays)
}

export const getDayBasedAging = (isoDate) => {
    const creationDate = parseISO(isoDate)
    const currentDate = new Date()

    const differenceInDays = differenceInCalendarDays(currentDate, creationDate)

    return differenceInDays <= 1 ? 1 : differenceInDays
}

export const heatMapDashboardDataConvertion = (is5x5, heatMapDatas) => {
    const rowMap = is5x5
        ? {
            Catastrophic: 0,
            Major: 1,
            Serious: 2,
            Marginal: 3,
            Negligible: 4
        }
        : {
            Catastrophic: 0,
            Serious: 1,
            Negligible: 2
        }

    const colMap = is5x5
        ? {
            Unlikely: 0,
            Remote: 1,
            Occasional: 2,
            Certain: 3,
            Frequent: 4
        }
        : {
            Unlikely: 0,
            Occasional: 1,
            Frequent: 2
        }

    const transformedData = heatMapDatas?.map(item => ({
        row: rowMap[item.row], // Convert row name to number
        col: colMap[item.col], // Convert col name to number
        value: item.value // Keep the value as is
    }))

    return transformedData
}

export const getDayBasedAgingInClosedBucket = (isoDate, modDate) => {
    const creationDate = parseISO(isoDate)
    const currentDate = parseISO(modDate)
    const differenceInDays = differenceInCalendarDays(currentDate, creationDate)

    return differenceInDays <= 1 ? 1 : differenceInDays
}

// const listMonths = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar' ]

export const freqCal = (frequency) => {
    switch (frequency) {
        case 1:
            return 1
        case 2:
            return 3
        case 3:
            return 6
        case 4:
            return 12
        default:
            break
    }
}
export const MonthScheduler = (cycle, frequency, complianceId, period = null, timeline) => {
    const year = new Date().getFullYear()
    const gap = freqCal(frequency)
    const date = new Date()
    date.setDate(1)
    date.setMonth(cycle - 1)
    date.setHours(0, 0, 0, 0)
    date.setFullYear(year)
    let dateLimit = new Date()
    dateLimit.setMonth(+cycle + 11)
    dateLimit.setDate(1)
    dateLimit.setDate(dateLimit.getDate() - 1)
    dateLimit.setHours(0, 0, 0, 0)
    const data = []
    while (date < dateLimit) {
        dateLimit = new Date(dateLimit)
        // const val = date.getMonth() + gap
        date.setMonth(date.getMonth() + gap)
        const disData = new Date(date.getTime() + 5.5 * 60 * 60 * 1000)
        disData.setHours(disData.getHours() - 24)
        console.log(disData)
        disData.setDate(disData.getDate() + (+timeline))

        const obj = {
            id: 0,
            complianceId,
            complianceTimelineId: 0,
            dueForMonth: date.getMonth() === 0 ? 12 : date.getMonth() || new Date().getMonth(),
            dueByMonth: disData.getMonth() + 1 || new Date().getMonth() + 1
        }
        data.push(obj)
        if (date > dateLimit) {
            break
        }
        date.setDate(1)
    }
    return data
}
// export const MonthScheduler = (cycle, frequency, complianceId, period = null, timeline) => {
//     const year = new Date().getFullYear()
//     const gap = freqCal(frequency)

//     // starting month
//     const date = new Date(year, cycle - 1, 1)
//     date.setHours(0, 0, 0, 0)

//     // 12 months range
//     const dateLimit = new Date(year, cycle + 11, 0)
//     dateLimit.setHours(0, 0, 0, 0)

//     const data = []

//     // selected target day (example: 30 or 31)
//     const targetDay = Number(timeline || 30) // <-- if timeline is your selected due day
//     // if timeline is NOT the selected day, replace with your actual selected day variable

//     while (date <= dateLimit) {

//         // ✅ DUE DATE SHOULD BE NEXT MONTH
//         const nextMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 1)

//         // ✅ find last valid day of next month
//         const lastDayOfNextMonth = new Date(
//             nextMonthDate.getFullYear(),
//             nextMonthDate.getMonth() + 1,
//             0
//         ).getDate()

//         // ✅ clamp 30 / 31 safely
//         const safeDay = Math.min(targetDay, lastDayOfNextMonth)

//         const dueDate = new Date(
//             nextMonthDate.getFullYear(),
//             nextMonthDate.getMonth(),
//             safeDay
//         )

//         const obj = {
//             id: 0,
//             complianceId,
//             complianceTimelineId: 0,

//             // current row month (Apr, May, Jun...)
//             dueForMonth: date.getMonth() + 1,

//             // due month (next month)
//             dueByMonth: dueDate.getMonth() + 1,

//             // optional if you want actual due date
//             dueDate: dueDate
//         }

//         data.push(obj)

//         // move by frequency
//         date.setDate(1)
//         date.setMonth(date.getMonth() + gap)
//     }

//     return data
// }
const getMonths = (timelineDay) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return months.map((m, i) => {
        const day = (m === "Feb" && (timelineDay === 30 || timelineDay === 31))
            ? 28
            : timelineDay;

        return {
            label: `${day}-${m}`,
            value: i + 1
        };
    });
};
export function generateMonthArray(startMonth, timelineDay) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const startIndex = startMonth
    if (startIndex === -1) throw new Error('Invalid start month name')

    const result = []
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth()
    const currentYear = currentDate.getFullYear()
    // Determine start year: if current month is after start month, use current year; else, use previous year
    const startYear = currentMonth + 1 >= startIndex ? currentYear : currentYear - 1

    // for (let i = 0; i < 12; i++) {
    //     const monthOffset = (startIndex + i) % 12
    //     const year = startYear + Math.floor((startIndex + i) / 12)
    //     const label = `${String(timelineDay).padStart(2, '0')}-${monthNames[monthOffset]}-year`
    //     const value = monthOffset + 1 // value without leading zero

    //     result.push({ label, value })
    // }
    return getMonths(timelineDay)
}

export const intDateConvert = (int) => {
    const arr = ('' + int).split('')
    const date = new Date()
    date.setFullYear(+arr.splice(0, 4).join(''))
    date.setMonth(+arr.splice(0, 2).join('') - 1)
    date.setDate(+arr.splice(0, 2).join(''))
    return date
}

export const DateintConvert = (date) => {
    return date.toISOString().slice(0, 10).replace(/-/g, '')
}

export const hasSingleData = (data) => data.length === 1
export const hasZeroData = (data) => data.length === 0

export function formatText(str) {
    return str
        .replace(/([A-Z])/g, ' $1') // insert space before capital letters
        .replace(/^./, s => s.toUpperCase()) // capitalize first letter
}
